export class UtilBloco {

  static blocosSintetico() : Array<string>{
      return [
          "bloco-divida-parceiros",
          "bloco-acoes-judiciais",
          "bloco-cheques-sem-fundo",
          "bloco-participacao-falencias",
          "bloco-protestos",
          "bloco-negativo-refin",
          "bloco-negativo-pefin",
          "bloco-negativo-convem",
          "hist-consulta-passagem-spc",
          "hist-consulta-passagem",
          "bloco-dividas-regularizadas-acoes-judiciais",
          "bloco-dividas-regularizadas-cheques-sem-fundo",
          "bloco-dividas-regularizadas-protestos",
          "bloco-dividas-regularizadas-serasa-refin",
          "bloco-dividas-regularizadas-serasa-pefin",
          "bloco-dividas-regularizadas-serasa-convem",
          "bloco-dividas-regularizadas-parceiros",
          "info-positivo",
          "info-cadastrais",
          "nota-credito",
          "participacao-societaria",

      ];
    }

}